/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import ConversationLimitFormQuery, {
	type ConversationLimitFormQuery as ConversationLimitFormQueryType,
} from '@jira/admin-pages__products-csm-chat/src/__generated__/ConversationLimitFormQuery.graphql.ts';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductsCsmChatEntryPointComponent = EntryPointComponent<
	{
		conversationLimitFormQuery: ConversationLimitFormQueryType;
	},
	{},
	{},
	{} | null
>;

export const productsCsmChatEntryPoint: EntryPoint<
	ProductsCsmChatEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ProductsCsmChatEntryPointComponent>(
		/* webpackChunkName: "async-products-csm-chat" */ './ProductsCsmChat.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { cloudId } = tenantContext;

		return {
			queries: {
				conversationLimitFormQuery: {
					options: { fetchPolicy: 'store-and-network' as const },
					parameters: ConversationLimitFormQuery,
					variables: { cloudId },
				},
			},
		};
	},
});
